<template>
  <NavLayoutNew />
  <div :class="style.mainSettingPage" :style="mainSettingPageStyle">
    <component :is="getNavComponent" />
  </div>
</template>
<script lang="ts">
import WidgetComponent from "@/widget/WidgetComponent.vue";
import style from "./StyleNav.module.scss";
import DoctorsComponent from "@/page/onlineAppointment/doctors/DoctorsComponent.vue";
import ServisesComponent from "@/page/onlineAppointment/services/ServicesComponent.vue";
import ClinicComponent from "@/page/onlineAppointment/clinic/ClinicComponent.vue";
import ApplicationComponent from "@/page/onlineAppointment/application/ApplicationComponent.vue";
import IntegrationComponent from "@/page/setting/integration/IntegrationComponent.vue";
import AccountComponent from "@/page/setting/account/AccountComponent.vue";
import QuizList from "@/page/quiz/editor/List/QuizList.vue";
import QuizSetting from "@/page/quiz/editor/QuizSetting.vue";
import StartHomePage from "@/page/start/startHomePage/startHomePage.vue";
import TariffPage from "@/page/setting/tariff/TariffPage.vue";
import {DOMAIN} from "@/http";
import NavLayoutNew from "@/layout/nav/NavLayoutNew.vue";
import {defineComponent} from "vue";
import {QuizListItem} from "@/page/quiz/typeQuiz";

export default defineComponent({
  components: {
    NavLayoutNew,
    DoctorsComponent,
    ServisesComponent,
    ClinicComponent,
    ApplicationComponent,
    AccountComponent,
    IntegrationComponent,
    QuizList,
    QuizSetting,
    WidgetComponent,
    StartHomePage,
    TariffPage
  },
  name: "navLayout",
  data() {
    return {
      style,
      navArr: [
        {
          name: "онлайн запись",
          route: "/setting",
          subItem: [
            {component: "ClinicComponent", name: "Клиника", path: "/setting"},
            {
              component: "DoctorsComponent",
              name: "Врачи",
              path: "/setting/doctors"
            },
            {
              component: "ServisesComponent",
              name: "Услуги",
              path: "/setting/services"
            },
            {
              component: "ApplicationComponent",
              name: "Заявки",
              path: "/setting/application"
            }
          ]
        },
        {
          name: "Квиз",
          route: "/quiz",
          subItem: [{component: "quizList", name: "Мои квизы", path: "/quiz"}]
        },
        {
          name: "Настройки",
          route: "/user",
          subItem: [
            {component: "AccountComponent", name: "Аккаунт", path: "/user"},
            {
              component: "IntegrationComponent",
              name: "Интеграции",
              path: "/user/integration"
            }
          ]
        }
      ],
      DOMAIN,
      louder: true
    };
  },
  created() {
    this.setDatas(this.getNavComponent);
  },
  async mounted() {
    this.$quizStore.fetchQuizList();
  },
  methods: {
    pushRouter(path: string) {
      const lastElementUrl = window.location.href.split("/").splice(-1)[0];
      if (
        window.location.href.includes("/quiz/setting/") &&
        path.includes("/quiz/setting/") &&
        lastElementUrl != "landingPage"
      ) {
        let pathArr = path.split("/");
        pathArr = pathArr.splice(0, pathArr.length - 1);
        pathArr.push(lastElementUrl);
        this.$router.push(pathArr.join("/"));
        return;
      }
      this.$router.push(path);
    },
    getSrcLogo() {
      let src = `https://${this.DOMAIN}/api/img?size=250x250&name=`;
      src += this.getClinic?.logo ? this.getClinic.logo : "logoWidget.svg";
      return src;
    },
    async setDatas(data: string) {
      await this.$clinicStore.fetchClinic();
      switch (data) {
        case "ServisesComponent":
          await this.$clinicStore.fetchSetting();
          break;
        case "AccountComponent":
          await this.$userStore.fetchUser();
          break;
        case "DoctorsComponent":
          await this.$doctorStore.fetchData();
          break;
      }
    },
    showWidget() {
      return this.getPath == "/setting";
    }
  },
  computed: {
    getQuizList(): QuizListItem[] {
      return this.$quizStore.getQuizList;
    },
    getClinic() {
      return this.$clinicStore.getClinic;
    },
    getPath() {
      return "/" + this.$route.path.split("/")[1];
    },
    getNavComponent() {
      return this.$route.meta?.children as string;
    },
    mainSettingPageStyle() {
      const navGroup = this.$route.meta.navGroup as string;
      if (
        [
          "setting",
          "settingServices",
          "settingDoctors",
          "landingPage",
          "configuration",
          "ABTest",
          "analytics"
        ].includes(navGroup)
      ) {
        return {
          left: "310px",
          width: "calc(100vw - 310px)"
        };
      }

      return {};
    }
  },
  watch: {
    getQuizList(data: QuizListItem[]) {
      this.navArr[1].subItem = this.navArr[1].subItem.filter((item) => {
        return item.component != "quizSetting";
      });
      const listPath = this.navArr[1].subItem;
      const quizList = data
        .map((quiz) => {
          const path = "/quiz/setting/" + quiz._id + "/landingPage";
          return {
            component: "quizSetting",
            name: quiz.name || "Без названия",
            path,
            img: false
          };
        })
        .filter(Boolean);
      this.navArr[1].subItem = listPath.concat(quizList);
      this.louder = false;
    },
    getNavComponent(data: string) {
      this.setDatas(data);
    }
  }
});
</script>
